import { Component, Input, OnInit } from '@angular/core';
import { ClientHomePage, PayrollTotals } from '../../../models/client';

@Component({
  selector: 'lib-last-payroll-tile',
  templateUrl: './last-payroll-tile.component.html',
  styleUrls: ['./last-payroll-tile.component.scss'],
  standalone: false
})
export class LastPayrollTileComponent implements OnInit {
  @Input()
  public payroll: PayrollTotals;

  ngOnInit(): void {}
}
